import { combineReducers } from 'redux';
import { userInterfaceReducer } from './userInterfaceReducer';
import { loginReducer } from './loginReducer';
import { documentsReducer } from './documentsReducer';
import { paymentsReducer } from './paymentsReducer';
import { customerDataReducer } from './customerDataReducer';
import { authenticationReducer } from './authenticationReducer';
import { customerSearchReducer } from './customerSearchReducer';
import { policyReducer } from './policyReducer';

const rootReducer = combineReducers({
  // Add your reducer references here
  // e.g. feature: featureReducer
  userInterface: userInterfaceReducer,
  login: loginReducer,
  documents: documentsReducer,
  payments: paymentsReducer,
  customerData: customerDataReducer,
  authentication: authenticationReducer,
  customerSearch: customerSearchReducer,
  policy: policyReducer
});

export default rootReducer;
